import React from 'react';
import './Settings.scss';
import {Outlet} from 'react-router-dom';
import NewSettingsMainPage from "components/newSettings/Settings.main";
import {launchDarkly} from "utils/launchDarkly";

export const Settings =()=>{

    const useNewSettings = launchDarkly.userClient?.variation("new-settings-page", false);


        return (
            <main className="settings-page d-flex justify-content-center align-items-start">
               <div className={"w-50 mt-24 p-8 radius-4"}>
                   { useNewSettings ? <NewSettingsMainPage/> :  <Outlet/>}
               </div>
            </main>
        );

}

export default Settings;
